import { render, staticRenderFns } from "./EditAccountTypesComponent.vue?vue&type=template&id=f42c8dae&"
import script from "./EditAccountTypesComponent.vue?vue&type=script&lang=js&"
export * from "./EditAccountTypesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports